import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ShieldAlert } from "lucide-react";

// Nudges members to verify their ID every time they sign in until they're verified.
export default function VerifyReminder() {
    const { user } = useAuth();
    const nav = useNavigate();
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (!user || user.role !== "member") return;
        if (user.verification_status === "verified") return;
        let seen = false;
        try { seen = sessionStorage.getItem("ssc_verify_reminded") === "1"; } catch (e) {}
        if (seen) return;
        try { sessionStorage.setItem("ssc_verify_reminded", "1"); } catch (e) {}
        const t = setTimeout(() => setOpen(true), 700);
        return () => clearTimeout(t);
    }, [user]);

    if (!user || user.role !== "member" || user.verification_status === "verified") return null;

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogContent data-testid="verify-reminder-dialog">
                <DialogHeader>
                    <DialogTitle className="flex items-center gap-2 text-primary">
                        <ShieldAlert className="h-5 w-5 text-accent" /> Finish verifying your account
                    </DialogTitle>
                    <DialogDescription>
                        You're not verified yet. Upload a photo ID — a driver's license, state ID, or passport — so we can confirm you're a real person. You'll be able to join outings and start matching once you're a Verified Member.
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter className="gap-2 sm:gap-2">
                    <Button variant="ghost" data-testid="verify-reminder-later" onClick={() => setOpen(false)}>Remind me later</Button>
                    <Button data-testid="verify-reminder-go" className="rounded-full bg-accent text-accent-foreground hover:bg-accent/90"
                        onClick={() => { setOpen(false); nav("/profile?tab=identity"); }}>
                        Upload my ID now
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
